import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/manualInvoicePaymentByKey', request)
}

export {put}
